import { ReactNode } from "react";
import permissionsStore from "../../../store/permissions";

type TContainerPermission = {
  children: ReactNode;
  permission: ("owner" | "collaborator" | "admin" | "support")[];
};

export const ContainerPermission: React.FC<TContainerPermission> = ({
  children,
  permission,
}) => {
  const { role } = permissionsStore();

  const verifyPermission = (permissions: string[]) =>
    role && permissions.length > 0 && permissions.some((p) => p === role);

  return verifyPermission(permission) ? <>{children}</> : <></>;
};

 